$(document).ready(() => {
  function generateIframe(signatureId) {
    const configuration = {};
    const iframeEndpoint = $('#signatureGeneratorContainer').data('universign-iframe-endpoint');
    configuration.redirectionMode = 'OUT';

    universignSigInit('iframeContainerId', signatureId, configuration, iframeEndpoint);
  }

  if ($('#signature-subscription-id').length) {
    App.cable.subscriptions.create(
      { channel: "SignatureChannel", subscription_id: $('#signature-subscription-id').data('id') }, {
        received(data) {
          if (data.status == "already_signed") {
            window.location.href = data.next_step_path;
          } else if (data.status == 'success') {
            $('#signature_button').removeClass('disabled');
            $('#dymanic_signature_instructions').text("Votre bulletin est généré, vous pouvez le signer dès maintenant.");
            $('#loader').addClass('d-none');
            $('#success_icon').removeClass('d-none');

            $('#signature_button').on('click', () => {
              generateIframe(data.signature_id);
              $('#signature_page_title').text("Signature de votre souscription");
              $('#dynamic_text_content').addClass('d-none');
              $('#signatureGeneratorContent').addClass('mt-5');
              $('#signatureGeneratorContainer').removeClass('vh-100');
              $('#signatureDocument').removeClass('d-none')
            });

          } else {
            $('#dymanic_signature_instructions').text("Une erreur est survenue, nos équipes sont en train de vérifier l'erreur, merci de réessayer ultérieurement");
            $('#loader').addClass('d-none');
          }
        }
      }
    );
  };
});
